// Auto-tracking delle pageview (opt-in `trackPageviews`). Emette una pageview al
// load e a ogni cambio di `pathname`, riusando il patch History condiviso
// (`navigation.ts`) — così breadcrumb di navigazione e pageview non doppiano il
// monkey-patch. Installato solo nel browser (l'`init` gata su `isBrowser()`).
//
// Dedup sul `pathname` (semantica Plausible, senza timer): un cambio di hash o un
// `replaceState` ripetuto sullo stesso path NON producono una nuova pageview.

import type { Client } from '../../client'
import { subscribeNavigation } from './navigation'

/// Emette la pageview iniziale e si iscrive ai cambi di pathname. Ritorna la
/// funzione di disinstallazione (disiscrive dal patch condiviso).
export function installPageviews(client: Client): () => void {
  client.capturePageview()
  let lastPathname = location.pathname

  return subscribeNavigation(() => {
    if (location.pathname === lastPathname) return
    lastPathname = location.pathname
    client.capturePageview()
  })
}
